import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinkedin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6 9.052q0-1.763 1.233-2.907T10.44 5q1.938 0 3.136 1.127 1.233 1.163 1.233 3.03 0 1.692-1.198 2.819-1.233 1.162-3.241 1.162h-.035q-1.938 0-3.136-1.162Q6 10.813 6 9.052m.458 30.827V16.345h7.821v23.534zm12.155 0h7.821V26.738q0-1.233.282-1.903a5.1 5.1 0 0 1 1.498-2.025q1.004-.828 2.519-.828 3.945 0 3.946 5.32v12.577H42.5V26.386q0-5.215-2.466-7.91t-6.518-2.695q-4.544 0-7.082 3.91v.071H26.4l.035-.07v-3.347h-7.821q.07 1.127.07 7.01 0 5.884-.07 16.524" })
});
export default SvgLinkedin;
